import { useContext, useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import DashboardLayout from "parts/LayoutContainers/DashboardLayout";
import DashboardNavbar from "parts/Navbars/DashboardNavbar";
import Footer from "parts/Footer";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import TimelineList from "parts/Timeline/TimelineList";
import TimelineItem from "parts/Timeline/TimelineItem";
import ProgressDashboard from "components/tasks/ProgressDashboard";

import { LanguageContext } from "context";
import { useSessionContext } from "context/SessionContext";

import { getTimeline, getTimerTimeline, getTasksProgress, type TimelineEntry, type PlanProgress } from "@shared/api/tasks";

function TaskProgress() {
  const { t } = useContext(LanguageContext) as any;

  const [timelineData, setTimelineData] = useState<TimelineEntry[]>([]);
  const [timerTimelineData, setTimerTimelineData] = useState<TimelineEntry[]>([]);
  const [progressData, setProgressData] = useState<PlanProgress[]>([]);
  const { session } = useSessionContext();

  useEffect(() => {
    const fetchTimeline = async () => {
      try {
        if (!session?.access_token) {
          return;
        }
        const data = await getTimeline(session.access_token);
        setTimelineData(data);
      } catch (err) {
        console.error("timeline取得エラー:", err);
      }
    };

    const fetchTimerTimeline = async () => {
      try {
        if (!session?.access_token) {
          return;
        }
        const data = await getTimerTimeline(session.access_token);
        setTimerTimelineData(data);
      } catch (err) {
        console.error("TImer-timeline取得エラー:", err);
      }
    };

    const fetchProgress = async () => {
      try {
        if (!session?.access_token) {
          return;
        }
        const data = await getTasksProgress(session.access_token);
        setProgressData(data);
      } catch (err) {
        console.error("timeline取得エラー:", err);
      }
    };

    fetchTimeline();
    fetchTimerTimeline();
    fetchProgress();
  }, [session?.access_token]);

  const renderTimelineItems = timelineData.map(
    ({ color, icon, title, dateTime, description, lastItem }: any) => (
      <TimelineItem
        key={title + dateTime}
        color={color}
        icon={icon}
        title={title}
        dateTime={dateTime}
        description={description}
        lastItem={lastItem}
      />
    )
  );

  const renderTimerTimelineItems = timerTimelineData.map(
    ({ color, icon, title, dateTime, description, lastItem }: any) => (
      <TimelineItem
        key={title + dateTime}
        color={color}
        icon={icon}
        title={title}
        dateTime={dateTime}
        description={description}
        lastItem={lastItem}
      />
    )
  );

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <MDTypography variant="h4" mb={2}>
          {t("TaskProgress")}
        </MDTypography>
        <MDTypography variant="h6">{t("TaskProgress1")}</MDTypography>
        <Card sx={{ mb: 3, p: 2 }}>
          {progressData.length > 0 && <ProgressDashboard data={progressData} />}
        </Card>
      </MDBox>
      <MDBox my={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={6}>
            <TimelineList title={t("Timeline-page.task_title")}>{renderTimelineItems}</TimelineList>
          </Grid>
          <Grid item xs={12} lg={6}>
            <TimelineList title={t("Timeline-page.pomorod_title")} dark>
              {renderTimerTimelineItems}
            </TimelineList>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default TaskProgress;
